import { Alert, Card, CardContent, Grid, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import PartnerCommissionApi from "../../../infrastructure/api/partnerCommissionApi";
import CopyTextField from "./components/CopyTextField";
import PartnerCommissionPageShell from "./components/PartnerCommissionPageShell";

const PartnerReferralPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [noPartnerProfile, setNoPartnerProfile] = useState(false);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    setNoPartnerProfile(false);
    try {
      const res = await PartnerCommissionApi.getReferral();
      const normalized = PartnerCommissionApi.normalize(
        res,
        "بارگذاری لینک معرف ناموفق بود."
      );
      if (normalized.noPartnerProfile) {
        setNoPartnerProfile(true);
        setData(null);
        return;
      }
      if (normalized.error) {
        setError(normalized.error);
        setData(null);
        return;
      }
      setData(normalized.data);
    } catch (e) {
      setError(e?.message || "خطا در بارگذاری");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <PartnerCommissionPageShell
      title="لینک معرف من"
      description="لینک و کد معرف برای اشتراک‌گذاری."
      loading={loading}
      error={error}
      noPartnerProfile={noPartnerProfile}
      onRetry={load}
    >
      <Alert severity="info" sx={{ mb: 2 }}>
        این لینک را برای معرفی متقاضیان سولارنت ارسال کنید.
      </Alert>

      <Card variant="outlined">
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CopyTextField
                label="کد معرف"
                value={data?.referralCode}
                copyMessage="کد معرف کپی شد."
              />
            </Grid>
            <Grid item xs={12}>
              <CopyTextField
                label="لینک معرف (مشتری)"
                value={data?.referralLink}
                copyMessage="لینک معرف کپی شد."
              />
            </Grid>
            {data?.partnerJoinLink ? (
              <Grid item xs={12}>
                <CopyTextField
                  label="لینک ثبت‌نام زیرمجموعه"
                  value={data.partnerJoinLink}
                  copyMessage="لینک ثبت‌نام زیرمجموعه کپی شد."
                />
              </Grid>
            ) : null}
            {data?.shareText ? (
              <Grid item xs={12}>
                <CopyTextField
                  label="متن اشتراک‌گذاری"
                  value={data.shareText}
                  copyMessage="متن اشتراک‌گذاری کپی شد."
                  multiline
                  rows={3}
                />
              </Grid>
            ) : null}
            {data?.qrCodePayload ? (
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary">
                  QR Payload
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: "break-all", mt: 0.5 }}>
                  {data.qrCodePayload}
                </Typography>
              </Grid>
            ) : null}
            {data?.campaignLinks?.length ? (
              <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  لینک‌های کمپین
                </Typography>
                {data.campaignLinks.map((item) => (
                  <CopyTextField
                    key={item.campaignCode || item.link}
                    label={item.campaignCode || "کمپین"}
                    value={item.link}
                    copyMessage="لینک کمپین کپی شد."
                  />
                ))}
              </Grid>
            ) : null}
          </Grid>
        </CardContent>
      </Card>
    </PartnerCommissionPageShell>
  );
};

export default PartnerReferralPage;
